import { TopServiceModeDefaultView } from './top-service-mode-default.view';
import { ITopServiceModeViewProps } from './types';

export const TopServiceModeView: React.FC<React.PropsWithChildren<
  ITopServiceModeViewProps
>> = props => {
  return <TopServiceModeDefaultView {...props} />;
};
